import { render, staticRenderFns } from "./SocialActivity.vue?vue&type=template&id=39f0459d&"
import script from "./SocialActivity.vue?vue&type=script&lang=js&"
export * from "./SocialActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports